import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getFieldsScript = (params) =>
  http
    .get(`/script/${params.script_id}/fields`, { params })
    .then((res) => res.data);

export const updateFieldsScript = ({ params, fieldsAltered }) =>
  http
    .post(`/script/${params.script_id}/fields`, fieldsAltered, { params })
    .then((res) => res.data);

export const getScriptById = (scriptId) =>
  http.get(`/script/${scriptId}`).then(handleResponse);
